const mxaTaskStatus = Object.freeze({
  READY: 0,
  IN_PROGRESS: 1,
  SUCCESS: 2,
  FAIL: 3,
  ERROR: 4
})

export { mxaTaskStatus }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/MxaTaskStatusEnum.js